export const checkArrayGetSum = (array) => {
  if (array && Array.isArray(array)) {
    return array
      .map(item => item?.amount ? parseFloat(item.amount) : 0)
      .reduce((total, num) => total + num, 0)
  } else return 0;
};